// import React, { useState, useEffect } from "react";
// import {
//   AppBar, Box, Container, IconButton, Drawer,
//   List, ListItem, ListItemButton, ListItemText, Typography, Button,
// } from "@mui/material";
// import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

// const NAVY   = "#1B1F3B";
// const YELLOW = "#FFD93D";
// const CORAL  = "#FF6B6B";
// const CREAM  = "#FFF8F0";

// const Navbar = ({ navItems, onNavigate, activeSection }) => {
//   const [scrolled, setScrolled]   = useState(false);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   useEffect(() => {
//     const handler = () => setScrolled(window.scrollY > 30);
//     window.addEventListener("scroll", handler, { passive: true });
//     return () => window.removeEventListener("scroll", handler);
//   }, []);

//   const handleNav = (id) => {
//     onNavigate(id);
//     setDrawerOpen(false);
//   };

//   return (
//     <>
//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           backgroundColor: scrolled ? CREAM : "rgba(255,248,240,0.96)",
//           backdropFilter: "blur(12px)",
//           borderBottom: `2.5px solid ${NAVY}`,
//           boxShadow: scrolled ? `0 4px 0 ${NAVY}` : "none",
//           transition: "all 0.3s ease",
//           zIndex: 1200,
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               minHeight: 68,
//             }}
//           >
//             {/* Logo */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1.5,
//                 cursor: "pointer",
//               }}
//               onClick={() => handleNav("hero")}
//             >
//               <Box
//                 component="img"
//                 src="/school-logo.png"
//                 alt="St Lord's School Logo"
//                 sx={{
//                   width: 46,
//                   height: 46,
//                   borderRadius: "50%",
//                   border: `2.5px solid ${NAVY}`,
//                   objectFit: "contain",
//                   backgroundColor: "#fff",
//                   p: 0.3,
//                   boxShadow: `3px 3px 0 ${NAVY}`,
//                   transition: "transform 0.2s",
//                   "&:hover": { transform: "rotate(-5deg) scale(1.05)" },
//                 }}
//               />
//               <Box>
//                 <Typography
//                   sx={{
//                     fontFamily: "'Fredoka One', cursive",
//                     fontSize: "1.12rem",
//                     color: NAVY,
//                     lineHeight: 1.1,
//                   }}
//                 >
//                   St Lord's
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontFamily: "'Space Grotesk', sans-serif",
//                     fontSize: "0.65rem",
//                     fontWeight: 700,
//                     color: CORAL,
//                     letterSpacing: "0.08em",
//                     textTransform: "uppercase",
//                   }}
//                 >
//                   Int'l Public School
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Desktop Nav */}
//             <Box
//               component="nav"
//               sx={{ display: { xs: "none", md: "flex" }, gap: 0.5, alignItems: "center" }}
//             >
//               {navItems.map((item) => {
//                 const active = activeSection === item.id;
//                 return (
//                   <Box
//                     key={item.id}
//                     component="button"
//                     onClick={() => handleNav(item.id)}
//                     sx={{
//                       px: 2,
//                       py: 0.75,
//                       border: active ? `2px solid ${NAVY}` : "2px solid transparent",
//                       borderRadius: "10px",
//                       backgroundColor: active ? YELLOW : "transparent",
//                       boxShadow: active ? `3px 3px 0 ${NAVY}` : "none",
//                       color: NAVY,
//                       fontFamily: "'Space Grotesk', sans-serif",
//                       fontWeight: 700,
//                       fontSize: "0.88rem",
//                       cursor: "pointer",
//                       transition: "all 0.15s ease",
//                       "&:hover": {
//                         backgroundColor: YELLOW,
//                         border: `2px solid ${NAVY}`,
//                         boxShadow: `3px 3px 0 ${NAVY}`,
//                       },
//                     }}
//                   >
//                     {item.label}
//                   </Box>
//                 );
//               })}
//               <Button
//                 variant="contained"
//                 size="small"
//                 onClick={() => handleNav("admissions")}
//                 sx={{
//                   ml: 1.5,
//                   px: 2.5,
//                   backgroundColor: CORAL,
//                   color: "#fff",
//                   border: `2px solid ${NAVY}`,
//                   boxShadow: `3px 3px 0 ${NAVY}`,
//                   "&:hover": { backgroundColor: "#FF8080" },
//                 }}
//               >
//                 Apply Now ✦
//               </Button>
//             </Box>

//             {/* Mobile hamburger */}
//             <IconButton
//               onClick={() => setDrawerOpen(true)}
//               sx={{
//                 display: { xs: "flex", md: "none" },
//                 border: `2px solid ${NAVY}`,
//                 borderRadius: "10px",
//                 boxShadow: `3px 3px 0 ${NAVY}`,
//                 backgroundColor: YELLOW,
//                 p: 0.8,
//               }}
//             >
//               <MenuRoundedIcon sx={{ color: NAVY }} />
//             </IconButton>
//           </Box>
//         </Container>
//       </AppBar>

//       {/* Mobile Drawer */}
//       <Drawer
//         anchor="right"
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         PaperProps={{
//           sx: {
//             width: 280,
//             backgroundColor: CREAM,
//             borderLeft: `3px solid ${NAVY}`,
//             px: 2,
//             pt: 3,
//           },
//         }}
//       >
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.4rem", color: NAVY }}>
//             Menu
//           </Typography>
//           <IconButton
//             onClick={() => setDrawerOpen(false)}
//             sx={{ border: `2px solid ${NAVY}`, borderRadius: "10px", p: 0.6 }}
//           >
//             <CloseRoundedIcon />
//           </IconButton>
//         </Box>
//         <List disablePadding>
//           {navItems.map((item) => (
//             <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
//               <ListItemButton
//                 onClick={() => handleNav(item.id)}
//                 sx={{
//                   borderRadius: "10px",
//                   border: `2px solid ${NAVY}`,
//                   backgroundColor: activeSection === item.id ? YELLOW : "#fff",
//                   boxShadow: `3px 3px 0 ${NAVY}`,
//                   "&:hover": { backgroundColor: YELLOW },
//                 }}
//               >
//                 <ListItemText
//                   primary={item.label}
//                   primaryTypographyProps={{
//                     fontFamily: "'Space Grotesk', sans-serif",
//                     fontWeight: 700,
//                     color: NAVY,
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//           <ListItem disablePadding sx={{ mt: 2 }}>
//             <Button
//               fullWidth
//               onClick={() => handleNav("admissions")}
//               sx={{
//                 backgroundColor: CORAL,
//                 color: "#fff",
//                 border: `2px solid ${NAVY}`,
//                 boxShadow: `3px 3px 0 ${NAVY}`,
//                 borderRadius: "10px",
//                 fontFamily: "'Space Grotesk', sans-serif",
//                 fontWeight: 800,
//                 "&:hover": { backgroundColor: "#FF8080" },
//               }}
//             >
//               Apply Now ✦
//             </Button>
//           </ListItem>
//         </List>
//       </Drawer>

//       {/* Spacer */}
//       <Box sx={{ height: 68 }} />
//     </>
//   );
// };

// export default Navbar;







import React, { useState, useEffect } from "react";
import {
  AppBar, Box, Container, IconButton, Drawer,
  List, ListItem, ListItemButton, ListItemText, Typography, Button,
  Popper, Paper, ClickAwayListener, MenuList, MenuItem, Grow,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SchoolIcon from '@mui/icons-material/School';
import AndroidIcon from '@mui/icons-material/Android';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LoginIcon from '@mui/icons-material/Login';
import GetAppIcon from '@mui/icons-material/GetApp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const NAVY = "#1B1F3B";
const YELLOW = "#FFD93D";
const CORAL = "#FF6B6B";
const CREAM = "#FFF8F0";

const Navbar = ({ navItems, onNavigate, activeSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [attendanceOpen, setAttendanceOpen] = useState(false);
  const [mobileAttendanceOpen, setMobileAttendanceOpen] = useState(false);
  const attendanceAnchorRef = React.useRef(null);
  const mobileAttendanceAnchorRef = React.useRef(null);

  const ATTENDANCE_URL = "https://attendance.stlordsinternationalpublicschool.com/";
  const ATTENDANCE_APK = "https://attendance.stlordsinternationalpublicschool.com/release/app-release.apk";

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const handleNav = (id) => {
    onNavigate(id);
    setDrawerOpen(false);
  };

  const handleAttendanceToggle = () => setAttendanceOpen((prev) => !prev);
  const handleAttendanceClose = (event) => {
    if (attendanceAnchorRef.current && attendanceAnchorRef.current.contains(event.target)) return;
    setAttendanceOpen(false);
  };

  const handleMobileAttendanceToggle = () => setMobileAttendanceOpen((prev) => !prev);
  const handleMobileAttendanceClose = (event) => {
    if (mobileAttendanceAnchorRef.current && mobileAttendanceAnchorRef.current.contains(event.target)) return;
    setMobileAttendanceOpen(false);
  };

  const ATTENDANCE_COLOR = "#B39DDB";

  const quickLinks = [
    {
      label: "Campus Management",
      url: "https://campus.stlordsinternationalpublicschool.com",
      icon: <SchoolIcon sx={{ fontSize: 18 }} />,
      color: "#4ECDC4",
    },
    {
      label: "Download APP",
      url: "http://stlordsinternationalpublicschool.com/release/app-release.apk",
      icon: <AndroidIcon sx={{ fontSize: 18 }} />,
      color: "#A8E6CF",
    },
    {
      label: "CRM",
      url: "https://leads.stlordsinternationalpublicschool.com",
      icon: <SupportAgentIcon sx={{ fontSize: 18 }} />,
      color: "#FF8B94",
    },
  ];

  return (
    <>
      {/* Top Quick Links Bar */}
      <Box
        sx={{
          backgroundColor: NAVY,
          borderBottom: `2px solid ${YELLOW}`,
          display: { xs: "none", md: "block" },
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1201,
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 0.5,
              py: 0.6,
            }}
          >
            {quickLinks.map((link, index) => (
              <Button
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                startIcon={link.icon}
                endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />}
                sx={{
                  color: "#fff",
                  backgroundColor: `${link.color}20`,
                  border: `1.5px solid ${link.color}40`,
                  borderRadius: "8px",
                  px: 2,
                  py: 0.4,
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  fontFamily: "'Space Grotesk', sans-serif",
                  textTransform: "none",
                  letterSpacing: "0.03em",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: `${link.color}40`,
                    border: `1.5px solid ${link.color}`,
                    transform: "translateY(-1px)",
                    boxShadow: `0 2px 8px ${link.color}40`,
                  },
                }}
              >
                {link.label}
              </Button>
            ))}

            {/* Attendance Dropdown */}
            <Box sx={{ position: "relative" }}>
              <Button
                ref={attendanceAnchorRef}
                onClick={handleAttendanceToggle}
                startIcon={<AccessTimeIcon sx={{ fontSize: 18 }} />}
                endIcon={
                  <ArrowDropDownIcon
                    sx={{
                      fontSize: 18,
                      transition: "transform 0.2s ease",
                      transform: attendanceOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                }
                sx={{
                  color: "#fff",
                  backgroundColor: `${ATTENDANCE_COLOR}20`,
                  border: `1.5px solid ${attendanceOpen ? ATTENDANCE_COLOR : ATTENDANCE_COLOR + "40"}`,
                  borderRadius: "8px",
                  px: 2,
                  py: 0.4,
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  fontFamily: "'Space Grotesk', sans-serif",
                  textTransform: "none",
                  letterSpacing: "0.03em",
                  transition: "all 0.2s ease",
                  backgroundColor: attendanceOpen ? `${ATTENDANCE_COLOR}40` : `${ATTENDANCE_COLOR}20`,
                  "&:hover": {
                    backgroundColor: `${ATTENDANCE_COLOR}40`,
                    border: `1.5px solid ${ATTENDANCE_COLOR}`,
                    transform: "translateY(-1px)",
                    boxShadow: `0 2px 8px ${ATTENDANCE_COLOR}40`,
                  },
                }}
              >
                Attendance
              </Button>
              <Popper
                open={attendanceOpen}
                anchorEl={attendanceAnchorRef.current}
                placement="bottom-end"
                transition
                disablePortal
                style={{ zIndex: 1300 }}
              >
                {({ TransitionProps }) => (
                  <Grow {...TransitionProps} style={{ transformOrigin: "right top" }}>
                    <Paper
                      elevation={8}
                      sx={{
                        mt: 0.5,
                        backgroundColor: NAVY,
                        border: `1.5px solid ${ATTENDANCE_COLOR}`,
                        borderRadius: "10px",
                        overflow: "hidden",
                        minWidth: 160,
                        boxShadow: `0 8px 24px rgba(0,0,0,0.4), 0 0 0 1px ${ATTENDANCE_COLOR}30`,
                      }}
                    >
                      <ClickAwayListener onClickAway={handleAttendanceClose}>
                        <MenuList dense sx={{ py: 0.5 }}>
                          {/* Login Option */}
                          <MenuItem
                            onClick={() => { window.open(ATTENDANCE_URL, "_blank"); setAttendanceOpen(false); }}
                            sx={{
                              color: "#fff",
                              fontFamily: "'Space Grotesk', sans-serif",
                              fontWeight: 700,
                              fontSize: "0.8rem",
                              gap: 1.5,
                              px: 2,
                              py: 1,
                              borderRadius: "6px",
                              mx: 0.5,
                              my: 0.3,
                              transition: "all 0.15s ease",
                              "&:hover": {
                                backgroundColor: `${ATTENDANCE_COLOR}30`,
                                color: ATTENDANCE_COLOR,
                                transform: "translateX(3px)",
                              },
                            }}
                          >
                            <LoginIcon sx={{ fontSize: 16, color: ATTENDANCE_COLOR }} />
                            Login
                            <OpenInNewIcon sx={{ fontSize: 12, ml: "auto", opacity: 0.6 }} />
                          </MenuItem>
                          {/* Divider */}
                          <Box sx={{ height: "1px", backgroundColor: `${ATTENDANCE_COLOR}30`, mx: 1 }} />
                          {/* App / Download Option */}
                          <MenuItem
                            component="a"
                            href={ATTENDANCE_APK}
                            download
                            onClick={() => setAttendanceOpen(false)}
                            sx={{
                              color: "#fff",
                              fontFamily: "'Space Grotesk', sans-serif",
                              fontWeight: 700,
                              fontSize: "0.8rem",
                              gap: 1.5,
                              px: 2,
                              py: 1,
                              borderRadius: "6px",
                              mx: 0.5,
                              my: 0.3,
                              textDecoration: "none",
                              transition: "all 0.15s ease",
                              "&:hover": {
                                backgroundColor: `#A8E6CF30`,
                                color: "#A8E6CF",
                                transform: "translateX(3px)",
                              },
                            }}
                          >
                            <GetAppIcon sx={{ fontSize: 16, color: "#A8E6CF" }} />
                            App
                            <GetAppIcon sx={{ fontSize: 12, ml: "auto", opacity: 0.6, color: "#A8E6CF" }} />
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Mobile Quick Links - Compact */}
      <Box
        sx={{
          backgroundColor: NAVY,
          borderBottom: `2px solid ${YELLOW}`,
          display: { xs: "flex", md: "none" },
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1201,
          justifyContent: "center",
          gap: 1,
          py: 0.5,
          px: 1,
        }}
      >
        {quickLinks.map((link, index) => (
          <IconButton
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#fff",
              backgroundColor: `${link.color}30`,
              border: `1px solid ${link.color}50`,
              borderRadius: "8px",
              p: 0.6,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: `${link.color}50`,
                transform: "scale(1.05)",
              },
            }}
            title={link.label}
          >
            {link.icon}
          </IconButton>
        ))}
        {/* Mobile Attendance Dropdown */}
        <Box sx={{ position: "relative" }}>
          <IconButton
            ref={mobileAttendanceAnchorRef}
            onClick={handleMobileAttendanceToggle}
            sx={{
              color: "#fff",
              backgroundColor: mobileAttendanceOpen ? `${ATTENDANCE_COLOR}50` : `${ATTENDANCE_COLOR}30`,
              border: `1px solid ${ATTENDANCE_COLOR}50`,
              borderRadius: "8px",
              p: 0.6,
              transition: "all 0.2s ease",
              "&:hover": { backgroundColor: `${ATTENDANCE_COLOR}50`, transform: "scale(1.05)" },
            }}
            title="Attendance"
          >
            <AccessTimeIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <Popper
            open={mobileAttendanceOpen}
            anchorEl={mobileAttendanceAnchorRef.current}
            placement="bottom-end"
            transition
            style={{ zIndex: 1300 }}
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} style={{ transformOrigin: "right top" }}>
                <Paper
                  elevation={8}
                  sx={{
                    mt: 0.5,
                    backgroundColor: NAVY,
                    border: `1.5px solid ${ATTENDANCE_COLOR}`,
                    borderRadius: "10px",
                    overflow: "hidden",
                    minWidth: 140,
                    boxShadow: `0 8px 24px rgba(0,0,0,0.4)`,
                  }}
                >
                  <ClickAwayListener onClickAway={handleMobileAttendanceClose}>
                    <MenuList dense sx={{ py: 0.5 }}>
                      <MenuItem
                        onClick={() => { window.open(ATTENDANCE_URL, "_blank"); setMobileAttendanceOpen(false); }}
                        sx={{
                          color: "#fff",
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontWeight: 700,
                          fontSize: "0.8rem",
                          gap: 1,
                          px: 1.5,
                          py: 0.8,
                          "&:hover": { backgroundColor: `${ATTENDANCE_COLOR}30`, color: ATTENDANCE_COLOR },
                        }}
                      >
                        <LoginIcon sx={{ fontSize: 15, color: ATTENDANCE_COLOR }} />
                        Login
                      </MenuItem>
                      <Box sx={{ height: "1px", backgroundColor: `${ATTENDANCE_COLOR}30`, mx: 1 }} />
                      <MenuItem
                        component="a"
                        href={ATTENDANCE_APK}
                        download
                        onClick={() => setMobileAttendanceOpen(false)}
                        sx={{
                          color: "#fff",
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontWeight: 700,
                          fontSize: "0.8rem",
                          gap: 1,
                          px: 1.5,
                          py: 0.8,
                          textDecoration: "none",
                          "&:hover": { backgroundColor: "#A8E6CF30", color: "#A8E6CF" },
                        }}
                      >
                        <GetAppIcon sx={{ fontSize: 15, color: "#A8E6CF" }} />
                        App
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Box>

      {/* Main Navbar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          top: { xs: 40, md: 36 },
          backgroundColor: scrolled ? CREAM : "rgba(255,248,240,0.96)",
          backdropFilter: "blur(12px)",
          borderBottom: `2.5px solid ${NAVY}`,
          boxShadow: scrolled ? `0 4px 0 ${NAVY}` : "none",
          transition: "all 0.3s ease",
          zIndex: 1200,
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: 68,
            }}
          >
            {/* Logo */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
              }}
              onClick={() => handleNav("hero")}
            >
              <Box
                component="img"
                src="/school-logo.png"
                alt="St Lord's School Logo"
                sx={{
                  width: 46,
                  height: 46,
                  borderRadius: "50%",
                  border: `2.5px solid ${NAVY}`,
                  objectFit: "contain",
                  backgroundColor: "#fff",
                  p: 0.3,
                  boxShadow: `3px 3px 0 ${NAVY}`,
                  transition: "transform 0.2s",
                  "&:hover": { transform: "rotate(-5deg) scale(1.05)" },
                }}
              />
              <Box>
                <Typography
                  sx={{
                    fontFamily: "'Fredoka One', cursive",
                    fontSize: "1.12rem",
                    color: NAVY,
                    lineHeight: 1.1,
                  }}
                >
                  St Lord's
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: "0.65rem",
                    fontWeight: 700,
                    color: CORAL,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                  }}
                >
                  International Public School
                </Typography>
              </Box>
            </Box>

            {/* Desktop Nav */}
            <Box
              component="nav"
              sx={{ display: { xs: "none", md: "flex" }, gap: 0.5, alignItems: "center" }}
            >
              {navItems.map((item) => {
                const active = activeSection === item.id;
                return (
                  <Box
                    key={item.id}
                    component="button"
                    onClick={() => handleNav(item.id)}
                    sx={{
                      px: 2,
                      py: 0.75,
                      border: active ? `2px solid ${NAVY}` : "2px solid transparent",
                      borderRadius: "10px",
                      backgroundColor: active ? YELLOW : "transparent",
                      boxShadow: active ? `3px 3px 0 ${NAVY}` : "none",
                      color: NAVY,
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontWeight: 700,
                      fontSize: "0.88rem",
                      cursor: "pointer",
                      transition: "all 0.15s ease",
                      "&:hover": {
                        backgroundColor: YELLOW,
                        border: `2px solid ${NAVY}`,
                        boxShadow: `3px 3px 0 ${NAVY}`,
                      },
                    }}
                  >
                    {item.label}
                  </Box>
                );
              })}
              <Button
                variant="contained"
                size="small"
                onClick={() => handleNav("admissions")}
                sx={{
                  ml: 1.5,
                  px: 2.5,
                  backgroundColor: CORAL,
                  color: "#fff",
                  border: `2px solid ${NAVY}`,
                  boxShadow: `3px 3px 0 ${NAVY}`,
                  "&:hover": { backgroundColor: "#FF8080" },
                }}
              >
                Apply Now ✦
              </Button>
            </Box>

            {/* Mobile hamburger */}
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{
                display: { xs: "flex", md: "none" },
                border: `2px solid ${NAVY}`,
                borderRadius: "10px",
                boxShadow: `3px 3px 0 ${NAVY}`,
                backgroundColor: YELLOW,
                p: 0.8,
              }}
            >
              <MenuRoundedIcon sx={{ color: NAVY }} />
            </IconButton>
          </Box>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            backgroundColor: CREAM,
            borderLeft: `3px solid ${NAVY}`,
            px: 2,
            pt: 3,
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.4rem", color: NAVY }}>
            Menu
          </Typography>
          <IconButton
            onClick={() => setDrawerOpen(false)}
            sx={{ border: `2px solid ${NAVY}`, borderRadius: "10px", p: 0.6 }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </Box>

        {/* Quick Links in Mobile Drawer */}
        <Box sx={{ mb: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
          {quickLinks.map((link, index) => (
            <Button
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={link.icon}
              endIcon={<OpenInNewIcon sx={{ fontSize: 12 }} />}
              size="small"
              sx={{
                backgroundColor: `${link.color}20`,
                border: `1.5px solid ${link.color}`,
                color: NAVY,
                borderRadius: "8px",
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 700,
                fontSize: "0.75rem",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: `${link.color}40`,
                  transform: "translateY(-1px)",
                },
              }}
            >
              {link.label}
            </Button>
          ))}
          {/* Attendance in drawer – Login */}
          <Button
            size="small"
            startIcon={<LoginIcon sx={{ fontSize: 15 }} />}
            onClick={() => window.open(ATTENDANCE_URL, "_blank")}
            sx={{
              backgroundColor: `${ATTENDANCE_COLOR}20`,
              border: `1.5px solid ${ATTENDANCE_COLOR}`,
              color: NAVY,
              borderRadius: "8px",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: "0.75rem",
              textTransform: "none",
              "&:hover": { backgroundColor: `${ATTENDANCE_COLOR}40`, transform: "translateY(-1px)" },
            }}
          >
            Attendance Login
          </Button>
          {/* Attendance in drawer – App download */}
          <Button
            size="small"
            component="a"
            href={ATTENDANCE_APK}
            download
            startIcon={<GetAppIcon sx={{ fontSize: 15 }} />}
            sx={{
              backgroundColor: "#A8E6CF20",
              border: "1.5px solid #A8E6CF",
              color: NAVY,
              borderRadius: "8px",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: "0.75rem",
              textTransform: "none",
              textDecoration: "none",
              "&:hover": { backgroundColor: "#A8E6CF40", transform: "translateY(-1px)" },
            }}
          >
            Attendance App
          </Button>
        </Box>

        <List disablePadding>
          {navItems.map((item) => (
            <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
              <ListItemButton
                onClick={() => handleNav(item.id)}
                sx={{
                  borderRadius: "10px",
                  border: `2px solid ${NAVY}`,
                  backgroundColor: activeSection === item.id ? YELLOW : "#fff",
                  boxShadow: `3px 3px 0 ${NAVY}`,
                  "&:hover": { backgroundColor: YELLOW },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontWeight: 700,
                    color: NAVY,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
          <ListItem disablePadding sx={{ mt: 2 }}>
            <Button
              fullWidth
              onClick={() => handleNav("admissions")}
              sx={{
                backgroundColor: CORAL,
                color: "#fff",
                border: `2px solid ${NAVY}`,
                boxShadow: `3px 3px 0 ${NAVY}`,
                borderRadius: "10px",
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 800,
                "&:hover": { backgroundColor: "#FF8080" },
              }}
            >
              Apply Now ✦
            </Button>
          </ListItem>
        </List>
      </Drawer>

      {/* Spacer for both top bar and main navbar */}
      <Box sx={{ height: { xs: 108, md: 104 } }} />
    </>
  );
};

export default Navbar;